import React from 'react'
import { connect } from 'react-redux'

import Step3View from './Step3View'

const Step3Wall = ({ isFetching, currentTemplate, company, variables, options, templates, name }) => (
  <Step3View
    info={{
      name: name,
      channel: name,
    }}
    isFetching={isFetching}
    currentTemplate={currentTemplate}
    company={company}
    variables={variables}
    options={options}
    templates={templates}
  />
)

export default connect()(Step3Wall)
